import React from 'react';
import PropTypes from 'prop-types';
import { menuToggler } from '@bd/bdcore-utilities';


class ToggleElementCustom extends React.Component {
  constructor(props) {
    super(props);

    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  handleKeyUp(e) {
    this.props.activateMenu('menu')(e);
    this.props.onKeyUp(e);
  }

  render() {
    const { activateMenu, button, children, className, isActiveMenu } = this.props;
    return (
      <div className={className}>
        <span
          className="Toggle_button mx-auto"
          role="button"
          tabIndex="0"
          onClick={activateMenu('menu')}
          onKeyUp={e => this.handleKeyUp(e)}
        >{button}<img src="/images/i-arrow-down-gold.svg" alt="" className="mx-2" /></span>
        {isActiveMenu('menu') && children}
      </div>
    );
  }
}

ToggleElementCustom.propTypes = {
  button: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func.isRequired,
};

ToggleElementCustom.defaultProps = {
  button: undefined,
  className: undefined,
};

export default menuToggler(ToggleElementCustom);



// WEBPACK FOOTER //
// ./src/components/ToggleElementCustom.js